export const services = [
  {
    title: 'AI Experiences',
    text: 'Characters, assistants and tools with personality, like Pixel. We design AI that feels on-brand, useful and genuinely fun to talk to.',
  },
  {
    title: 'Branding',
    text: 'We build brands people actually feel. Strategy, naming, identity and voice, shaped into a system that stays surprising long after launch day.',
  },
  {
    title: 'Digital Products',
    text: 'Apps and platforms that feel human. We blend product thinking with behavioural insight, so every screen is useful, intuitive and a little bit delightful.',
  },
  {
    title: 'Websites',
    text: 'Sites that tell your story and move people to act. Editorial layouts, crafted motion and fast, accessible builds that are easy for your team to run.',
  },
  {
    title: 'Motion & 3D',
    text: 'Logos that breathe, products that spin and campaigns that move. We bring brands to life with animation, 3D and interactive moments.',
  },
  {
    title: 'Content',
    text: 'Art direction, photography and copy that sound like you. Assets made to perform across every channel, from launch films to social.',
  },
];
